(() => {
  const ROOT = '[data-siblings]';

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(ROOT).forEach((root) => {
      const handle = root.getAttribute('data-siblings-handle');
      if (!handle) return;
      hydrate(root, handle).catch((e) => console.error('[siblings] error', e));
    });
  });

  async function hydrate(root, collectionHandle) {
    const currentHandle = root.getAttribute('data-current-handle') || '';
    const soldOutText = root.getAttribute('data-soldout-text') || 'Sold out';
    const squares = root.getAttribute('data-squares') === '1';
    const optionSize = Number(root.getAttribute('data-option-size') || 50);

    const wrapper = root.querySelector('[data-swapper-wrapper]');
    const target = root.querySelector('[data-swapper-target]');
    const grid = root.querySelector('[data-siblings-grid]');
    if (!grid || !wrapper) return;

    // Fetch all pages
    let page = 1;
    let products = [];

    while (true) {
      const url = `/collections/${collectionHandle}?view=siblings-ajax&page=${page}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) break;

      const data = await res.json();
      if (Array.isArray(data.products)) products = products.concat(data.products);

      if (!data.next_page) break;
      page = Number(data.next_page);
      if (!page) break;
    }

    // If 0/1 sibling, hide block
    if (products.length <= 1) {
      root.style.display = 'none';
      return;
    }

    // Render
    grid.innerHTML = '';
    const frag = document.createDocumentFragment();

    products.forEach((p) => {
      const isCurrent = p.handle === currentHandle;
      const isSoldOut = p.available === false;

      const modifier = [
        isSoldOut ? 'siblings__link--sold-out' : '',
        isCurrent ? 'siblings__link--current' : ''
      ].filter(Boolean).join(' ');

      const colorName = (p.cutline || '').toString().trim() || p.handle;

      const ariaLabel = isSoldOut ? `${colorName} - ${soldOutText}` : colorName;

      const a = document.createElement('a');
      a.href = p.url;
      a.className = `siblings__link ${modifier}`.trim();
      a.setAttribute('data-swapper-hover', colorName);
      a.title = colorName;
      a.setAttribute('aria-label', ariaLabel);
      if (isCurrent) a.setAttribute('aria-current', 'true');

      // Keep inner structure identical
      const swatch = document.createElement('div');
      swatch.className = 'siblings__swatch';

      const imageWrap = document.createElement('div');
      imageWrap.className = `sibling__image${squares ? ' sibling__image--square' : ''}`;

      // Use <img> (Liquid render 'image' isn't available in JS)
      if (p.image) {
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = colorName;
        img.width = optionSize;
        img.height = optionSize;
        img.src = p.image;
        imageWrap.appendChild(img);
      }

      swatch.appendChild(imageWrap);
      a.appendChild(swatch);
      frag.appendChild(a);

      // Update legend value for current
      if (isCurrent && target) {
        target.textContent = colorName;
      }
    });

    grid.appendChild(frag);
  }
})();
